import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { UtilidadesCrudService } from '@appNeo/neoShared/services/utilidades/utilidades-crud.service';
import { Observable, catchError, of, forkJoin, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService extends UtilidadesCrudService {

  constructor(http: HttpClient, auxiliar: AuxiliarService) {
    super(
      http,
      auxiliar,
      'banner',
      'banner',
      'Banner',
      'Banners',
      [
        'id'
      ]
    );
  }

  // Sobreescribe get sin id. Banner no tiene listado.
  get(): Observable<any> {
    return this.http.get(`${this.urlEntidad}`).pipe(
        map((data: IRespApi) => this.mapearEntidad(data['data'])),
        catchError((err: IRespApi) => {
            return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
        })
    );
  }

  asociarImagen(idBanner: string, request: any): Observable<any> {
    return this.http.post(`${this.urlEntidad}/${idBanner}/ficheros`, request).pipe(
        map((data: IRespApi) => this.mapearEntidad(data['data'])),
        catchError((err: IRespApi) => {
            return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
        })
    );
  }

  editarImagen(idFichero: string, request: any): Observable<any> {
    return this.http.patch(`${this.urlEntidad}/${idFichero}/ficheros`, request).pipe(
        map((data: IRespApi) => this.mapearEntidad(data['data'])),
        catchError((err: IRespApi) => {
            return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
        })
    );
  }

  eliminarImagen(idBanner: string, request: any) {  
    return this.http.delete(`${this.urlEntidad}/${idBanner}/fichero`, {body: request}).pipe(
      catchError((err: IRespApi) => {
        return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
      })
    );
  }

  

  /************************************ 
* Funciones apoyo                  *
*************************************/
resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
  let peticion = {
    entidad: this.get().pipe(
      catchError(err => of(null))
    )
  };
  return forkJoin(peticion);
}

}
